/**
 * @file 其他联系方式组件
 * @description 根据 contact_method_wrap 数据结构渲染其他联系方式列表
 * @author hukeke01
 */
import React from 'react';
import ContactItem from '../ContactItem';
import iconWechat from '../../pages/normalLandPage/imgs/pc-icon-weixin.svg';
import iconWeibo from '../../pages/normalLandPage/imgs/pc-icon-weibo.svg';
import iconQQGroup from '../../pages/normalLandPage/imgs/icon-qq-group.png';
import iconXiaohongshu from '../../pages/normalLandPage/imgs/xiaohongshu.png';
import iconEmail from '../../asset/img/businessCard/email-blue.png';
import iconContact from '../../asset/img/businessCard/icon_qitalianxi_pc.svg';

import './style.less';

interface ContactMethod {
    name: string;
    value: string;
    order: number;
    url?: string;
    isShowCard: boolean;
}

interface ContactMethodWrapData {
    contact_method: ContactMethod[];
}

interface IContactMethodWrapProps {
    /** contact_method_wrap 数据 */
    data?: ContactMethodWrapData;
    /** 复制回调，参数为 (type, value) */
    copyCallback?: (type: string, value: string) => void;
}

/** 已知联系方式类型对应的显示配置 */
const CONTACT_TYPE_CONFIG: Record<string, {label: string; icon: string}> = {
    weixin: {label: '企业官方微信', icon: iconWechat},
    qq_group: {label: '企业官方QQ群', icon: iconQQGroup},
    email: {label: '企业官方邮箱', icon: iconEmail},
    weibo: {label: '企业官方微博', icon: iconWeibo},
    xiaohongshu: {label: '企业官方小红书', icon: iconXiaohongshu},
};

export default function ContactMethodWrap(props: IContactMethodWrapProps) {
    const {data, copyCallback} = props;

    // 无数据或空数组时，不渲染
    if (!data?.contact_method?.length) {
        return null;
    }

    // 全部展示，不做筛选，按 order 排序
    const visibleMethods = [...data.contact_method].sort((a, b) => a.order - b.order);

    if (visibleMethods.length === 0) {
        return null;
    }

    return (
        <div>
            <p className="bord" />
            <div className="mt22">
                <div className="title-label mb25">
                    <div className="title-part">
                        <img
                            className="icon"
                            src={iconContact}
                            alt=""
                        />
                        <span className="kftxt">其他联系方式</span>
                    </div>
                </div>
                <div className="item-wrap">
                    {visibleMethods.map(item => {
                        const config = CONTACT_TYPE_CONFIG[item.name];
                        const label = config?.label || item.name;
                        const icon = config?.icon || '';

                        return (
                            <ContactItem
                                key={`${item.name}-${item.value}`}
                                contactIcon={icon || undefined}
                                contactName={label}
                                contactSubtext={item.value}
                                copyText={item.value}
                                copyCallback={() => copyCallback?.(item.name, item.value)}
                                picQrCode={item.url}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}